var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQqInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.374 15.127a1.125 1.125 0 102.25 0 1.125 1.125 0 00-2.25 0zm1.688-2.626a.188.188 0 00.187-.187V5.939a.188.188 0 00-.188-.188H9.938a.188.188 0 00-.188.188v6.375c0 .103.084.188.188.188h1.125zm9.374-4.406h-1.39a.185.185 0 00-.152.078l-2.496 3.44-1.17-1.612a.185.185 0 00-.152-.078h-1.39c-.152 0-.24.174-.152.298l2.56 3.532a.378.378 0 00.609 0l3.886-5.36a.188.188 0 00-.152-.298zm-1.03 7.172H17.9a.383.383 0 00-.32.176 8.259 8.259 0 01-1.166 1.458 8.32 8.32 0 01-5.906 2.442A8.329 8.329 0 014.601 16.9a8.275 8.275 0 01-1.79-2.653 8.266 8.266 0 01-.657-3.246c0-1.126.22-2.22.657-3.247a8.275 8.275 0 011.79-2.653 8.32 8.32 0 015.906-2.442 8.329 8.329 0 015.907 2.442c.445.446.834.933 1.167 1.458.068.11.19.176.319.176h1.504c.14 0 .23-.148.169-.272A10.14 10.14 0 0010.633.876C5.036.811.386 5.388.374 10.983c-.012 5.599 4.53 10.143 10.134 10.143 3.966 0 7.397-2.273 9.064-5.587a.187.187 0 00-.167-.272z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/qq_info.983040eaebee47d203b6533af5f4c34d.svg";
export { SvgQqInfo as ReactComponent };